import { removeChildren } from './html.js';
import { AmiWatcher } from './watcher.js';

export function AmiEmoticonList(parent) {
    var container = <div id="emotes" />;
    var watcher = new AmiWatcher;
    parent.appendChild(container);

    var clear = function() {
        removeChildren(container);
    };

    var add = function(emote) {
        container.appendChild(<img src={emote.url} alt={emote.strings[0]} title={emote.strings[0]} onclick={() => { watcher.call(emote, [emote]); }} />);
    };

    var hide = function() { container.classList.add('hidden'); };
    var show = function() { container.classList.remove('hidden'); };

    return {
        clear: clear,
        hide: hide,
        show: show,
        add: add,
        render: function(emotes, minRank) {
            clear();
            if(emotes.any(minRank)) {
                emotes.forEach(minRank, add);
                show();
            } else hide();
        },
        watch: watcher.watch,
        unwatch: watcher.unwatch,
    };
};

export function AmiEmoticons() {
    var emotes = [];

    var clear = function() {
        emotes = [];
    };

    var add = function(emote) {
        if(emote.url.substring(0, 6) === 'https:')
            emote.url = emote.url.substring(6);

        emotes.push(emote);
    };

    return {
        clear: clear,
        add: add,
        load: function(batch) {
            for(var i in batch)
                add(batch[i]);
        },
        forEach: function(minRank, callback) {
            if(minRank === undefined) minRank = 0;
            for(var i in emotes) {
                var emote = emotes[i];
                if(!emote.min_rank || emote.min_rank <= minRank)
                    callback(emote);
            }
        },
        any: function(minRank) {
            if(minRank === undefined) minRank = 0;
            for(var i in emotes)
                if(!emotes[i].min_rank || emotes[i].min_rank <= minRank)
                    return true;
            return false;
        },
        findByName: function(minRank, name, returnString) {
            var found = [];
            for(var i in emotes) {
                var emote = emotes[i];
                if(!emote.min_rank || emote.min_rank <= minRank) {
                    for(var j in emote.strings) {
                        var string = emote.strings[j];
                        if(string.indexOf(name) === 0) {
                            found.push(returnString ? string : emote);
                            break;
                        }
                    }
                }
            }
            return found;
        },
    };
};
